import config from '../../constants/config';
import { getCleanUsername } from '../helpers/utils';

export default {
  and: 'és',
  SignUp: 'Regisztráció',
  LogIn: 'Bejelentkezés',
  LOGIN: 'BEJELENTKEZÉS',
  Close: 'Bezárás',
  Ok: 'OK',
  Back: 'Vissza',
  He: 'Férfi',
  She: 'Nő',
  Him: 'Férfit',
  Her: 'Nőt',
  Find: 'Keresés',
  Thanks: 'Köszi',
  SingUpLanding: 'Koppints ide a kereséshez',
  LogInLanding: 'Van már fiókod? Bejelentkezés',
  TitleLanding: 'Unod már a régi társkereső oldalakat?',
  SubTitleLanding:
    'Mi is! Szerezz felejthetetlen élményeket a(z) ' +
    config.TITLE +
    ' oldalon, és vedd igénybe ezen lehetőségek valamelyikét:',
  logInWithApple: 'Bejelentkezés Apple azonosítóval',
  mailIsConfirmed:
    'Gratulálunk! Sikeresen aktiváltuk a fiókját. Köszönjük, hogy megerősítette az e-mail címét. Most már teljes körű hozzáférést élvezhet szolgáltatásainkhoz.',
  SignUpWithEmail: 'Regisztrálj e-mail címmel',
  reactivateAccount: 'Fiók újraaktiválása',
  welcomeBack: 'Üdv újra',
  prevYouDeactivYourAcc: 'Korábban deaktiváltad fiókod',
  doUwantToReacYourAcc: 'Szeretnéd-e újraaktiválni fiókod',
  yesReactivateMyAcc: 'Igen, szeretném újraaktiválni fiókom',
  noKeepDeactivated: 'Nem, inkább maradjon deaktiválva',
  signUpWithApple: 'Regisztrálj Apple azonosítóval',
  TermsOfService: 'Általános\u00A0szerződési\u00A0feltételek',
  PrivacyPolicy: 'Adatvédelmi\u00A0Nyilatkozat',
  AntiHumanTraffickingPolicy: 'Emberkereskedelem Elleni Politika',
  ContentPolicy: 'Hozzájárulás/Tartalom',
  JoinToday: 'Csatlakozz még ma',
  firstName: 'Keresztnév',
  yourFirstName: 'Először is, add meg keresztneved',
  EmailAddress: 'E-mail cím',
  password: 'Jelszó',
  EnterEmailAddress: 'Írd be e-mail címed',
  EnterPassword: 'Írd be a jelszavad',
  PleaseEnterValidEmail: 'Kérünk, adj meg egy érvényes e -mail címet',
  PleaseEnterPassword: 'Kérünk, írd be a jelszavad',
  LandPageHeader: 'Készen állsz egy újabb kalandra?',
  LandPageSubHeader:
    config.NICHE_SINGULAR.replace(/\w/, (c) => c.toUpperCase()) +
    ' A randizás összeköt ' +
    config.NICHE_SINGULAR +
    ' romántikára vágyó szinglik',
  LandPageLegal: 'A bejelentkezéssel elfogadod',
  LandPageAllDevices: 'Elérhető minden eszközön',
  ForgotYourPassword: 'Elfelejetett jelszó?',
  or: 'vagy',
  Save: 'Mentés',
  views: 'Megtekintések',
  view: 'Megtekintés',
  ViewedMyProfile: 'Megtekintett profil',
  ViewProfile: 'Profil megtekintése',
  UnmatchDelete: 'Nem hozzám illő / Törlés',
  UnmatchDeleteQuestionMark: 'Partnerjelölt eltávolítása/törlése?',
  UnmatchDeleteText:
    'Biztosan el szeretné távolítani a felhasználót a jelöltek listájáról? A jövőben nem férhet hozzá csevegési előzményeihez a következő felhasználóval: ',
  YesUnmatchDelete: 'Igen, párosítás visszavonása/törlése',
  IViewed: 'Lecsekkoltam',
  ViewedMe: 'Lecsekkoltak',
  LikesMe: 'Bír engem',
  Mutual: 'Kölcsönös',
  MyLikes: 'Tetszéseim',
  Chat: 'Csevegés',
  Flirts: 'Flörtikonok',
  Send: 'Küldés',
  typing: 'gépelés',
  UpgradeToVIP: 'Felminősítés VIP tagságra',
  TypeAMessageHere: 'Ide írd be az üzeneted',
  FeaturesChat: 'Csevegés',
  SendMessagesToWhoYouWant: 'Küldj üzenetet bárkinek',
  SeeWhoIsInterestedInYou: 'Nézd meg, hogy ki érdeklődik irántad',
  SeeWhoIsReallyInterestedInYou:
    'Nézd meg, ki az, aki igazán érdeklődik irántad',
  IncreaseYourChancesWithAFlirt: 'Növeld meg esélyeid egy flörtikonnal',
  GetDatesFast: 'Mondj igent vagy nemet és randizz kedvedre',
  FeaturesIncluded: 'Funkciók',
  Matches: 'Partnerjelöltek',
  Likes: 'Lájkok',
  QuickMatch: 'Villám randi',
  Search: 'Keresés',
  Favorite: 'Kedvenc',
  Favorites: 'Kedvencek',
  Browse: 'Böngészés',
  MyProfile: 'Profilom',
  Settings: 'Beállítások',
  // Logout
  LogoutH1: 'Sikeresen kijelentkeztél',
  LogoutP: 'Hiányolni fogunk...',
  LogoutButton: 'Jelentkezz be újra',
  // Unsubscribe
  tooManyEmails: 'Túl sok e-mail',
  enterYourEmailBelowToUnsub:
    'A leiratkozáshoz, add meg az e-mail címed a folytatásban',
  unsubscribe: 'Leiratkozás',
  unsubscribeSuccess: 'Sikeres leiratkozás',
  youWillNoLongerReceiveAnyEmailFromUs: 'Többé nem kapsz tőlünk e-maileket',
  unSubByAccident: 'Véletlen leiratkozás',
  reSubHere: 'Iratkozz fel újra itt',
  helpUsGetBetter: 'Segíts nekünk, hogy jobbak legyünk',
  tellUsWhyYouUnSub: 'Mondd el nekünk, hogy miért iratkoztál le',
  resubscribeSuccessful: 'Sikeres újra feliratkozás',
  clickHere: 'Kattints ide',
  toGoBackToTheSite: 'és térj vissza a honlapra',
  pleaseSelectOneOfTheReasonsBelow:
    'Kérjük, válassz egyet az alábbi okok közül',
  notEnoughUsers: 'Nincs elegenndő felhasználó',
  complicatedToUse: 'Nem felhasználóbarát',
  notEnoughOptions: 'Nincs elegendő opció',
  betterAlternatives: 'Jobb alternatívák',
  badExperienceWithAnotherUser: 'Rossz tapasztalat egy másik felhasználóval',
  technicalIssues: 'Technikai problémák',
  thanksForYourFeedback: 'Köszönjük a visszajelzést',
  tapHere: 'Tappints ide',
  // Who's online
  WhosOnline: 'Elérhető felhasználók',
  Recent: 'Legútóbbi',
  ThisWeek: 'Ezen a héten',
  MembsWereOnlineRec: 'A felhasználók nemrég online voltak',
  MembsWereOnlineWeek: 'A felhasználók online voltak ezen a héten',
  MembsRecWillAppHere: 'A közelmúltban elérhető felhasználók itt jelennek meg',
  MembsThisWeekWillAppHere: 'A héten elérhető felhasználók itt jelennek meg',
  // Browse
  BrowseZero: 'Összesen',
  BrowseZero2: 'felhasználó',
  BrowseMembersAppear: 'A felhasználók itt jelennek meg',
  // Favorites
  MyFavorites: 'Kedvenceim',
  FavoritedMe: 'Kedvencnek jelölt',
  YourFavWillAppHere: 'A kedvencek itt jelennek meg',
  MembHaveFavU: 'A felhasználók kedvencnek jelöltek',
  MembWhoFavU: 'A felhasználók akik kedvencnnek jelöltek, itt jelennek meg',
  NewPasswordSet: 'Új jelszó beállítva. Most már bejelentkezhetsz.',
  // Password Recovery
  recoveryTittle: 'Jelszó helyreállítás',
  recoveryButton: 'Jelszó visszaállítás',
  goBackToLogIn: 'Vissza a bejelentkezéshez',
  recoveryMessage1:
    'Ha létezik ilyen e-mail címmel renndelkező fiók, akkor folytatjuk a jelszó-helyreállítási folyamatot.',
  NewPassword: 'Új jelszó',
  SetNewPassword: 'Új jelszó beállítása',
  // Info Line
  NotShared: 'Nincs megosztva',
  // Create Account Email Register
  byCreatingYourAccount: 'Az oldalhoz való csatlakozással elfogadom a ',
  alsoAgree:
    'Emelett, egyezem azzal, hogy üzeneteket, fiókkal kapcsolatos információkat és különleges ajánlatokat tartalmazó üzeneteket kapjak.',
  picturesDisclaimer:
    'A kép illusztráció, a Tartalomban ábrázolt bármely személy pedig modell',
  step: 'Lépés',
  // GenderStep
  StepsTitle:
    'Csatlakozz és ismerkedje ' +
    (config.NICHE_SINGLES
      ? config.NICHE_SINGLES
      : config.NICHE_PLURAL.replace(/\b\w/g, (c) => c.toUpperCase())) +
    ' Szerelmesek Most!',
  gender: 'Nem',
  startMeeting: 'Ismerkedjen most',
  weNeedInfo: 'Csak néhány információra van szükségünk',
  iAm: 'Nem:',
  near: 'Környék:',
  seeking: 'Kit keresek:',
  next: 'Következő',
  viewOtherOptions: 'További lehetőségek megtekintése',
  // LocationStep
  location: 'Tartózkodási hely',
  WhereAreYouLocated: 'Hol tartózkodsz?',
  WellFindMatchesInYourArea: 'A környéken keresünk neked partnerjelölteket',
  EnterYourCityOrLocation: 'Adja meg tartózkodási helyét:',
  // AgeStep
  age: 'Életkor',
  howOldAreYou: 'Milyen idős vagy?',
  enterAgeBelow: 'Add meg életkorod az alábbiakban',
  ageLabel: 'Életkor:',
  agePlaceholder: 'A korod',
  ageError: 'Legalább < és > évesnek kell lenned',
  EnterYourAge: 'Add meg az életkorod',
  // UsernameStep
  username: 'Felhasználónév',
  chooseUsername: 'Válassz felhasználónevet',
  itWillBeYourBio: 'A profilodon szerepel ez az adat',
  usernamePlaceholder: 'Például: ' + getCleanUsername(config.NICHE_SINGULAR),
  chooseAUsername: 'Válassz felhasználónevet',
  usernameError: 'Ez a felhasználónév érvénytelen',
  usernameLabel: 'Felhasználónév',
  usernameLabelSmall: '(6-14 betű és számjegy)',
  enterYourNewUsername: `Adja meg új felhasználónevét (e.g. ${getCleanUsername(
    config.NICHE_SINGULAR
  )})`,
  lettersAndNumbersOnly: 'Csak betűket és számokat használjon',
  useAtLeastOneLetter: 'Használjon legalább egy betűt',
  // EmailStep
  emailPassword: 'E-mail/Jelszó',
  youAreDone: 'Majdnem kész vagy...',
  createYourAccount: 'Hozd létre fiókod az alábbiakban',
  createAccount: 'Fiók létrehozása',
  emailError: 'Adj meg egy érvényes e-mail címet',
  emailGmailTypoError: 'Gmail domainre gondoltál?',
  passwordError: 'A jelszó minimális hossza 6 karakter',
  enterYourPassword: 'Add meg a jelszavad',
  useMinChar: 'Használj legalább 6 karaktert',
  ageMissingHeadline: 'Életkor kérelem',
  EnterYourEmailAddress: 'Írd be az email címed',
  ChooseAPassword: 'Válassz jelszavat',
  itWiilBeUsedForLogin: 'A bejelentkezéshez használjuk',
  // PasswordStep
  choosePassword: 'Válassz jelszót',
  // EmailAndPasswordStep
  enterEmailAndPassword: 'Adja meg e-mail címét, és válassza a Jelszót',
  // Auto-complete
  EnterYourLocation: 'Add meg tartózkodási helyed',
  EnterYourCityOrZipCode:
    'Add meg a település nevét vagy irányítószámát az alábbiakban:',
  enterCityOrZip: 'Add meg a település nevét vagy irányítószámát',
  Menu: 'Menü',
  More: 'Még több',
  // Matches
  noMatchesFound: 'Nincs találat',
  wantMoreMatches: 'Több partnerjelöltet szeretnél?',
  tapButtonBelow:
    'A párosítási beállítások módosításához koppints az alábbi nyomógombra',
  editMatchPreferences: 'Párosítási módosítása',
  // MyLikes
  youHave: 'Neked',
  increaseYourMatches:
    'Koppints a "Induljon a lájkolás" nyomógombra az alábbiakban, és növeld meg partnerjelöltjeid számát',
  startLiking: 'Induljon a lájkolás',
  // Mutual
  mutualLikes: 'Kölcsönös kedvelések',
  // LikesMe
  membersHaveLikedYou: 'A felhasználók lájkoltak téged',
  // MyViews
  youHaveViewed: 'Lecsekkoltad',
  profiles: 'profilokat',
  membersWhoYouViewed: 'A megtekintett felhasználók itt jelennek meg',
  // ViewedMe
  memberViewedYou: 'A felhasználók lecsekkoltak téged',
  memberWhoViewYourProfile:
    'A felhasználók akik lecsekkoltak téged itt jelennek meg',
  // Settings
  logout: 'Kijelentkezés',
  general: 'általános',
  account: 'fiók',
  legal: 'jogi',
  support: 'támogatás',
  matchPref: 'Partnerjelölt beállítások',
  emailPref: 'E-mail beállítások',
  privacyStgs: 'Adatvédelmi beállítások',
  reactivateVipMbership: 'VIP tagság újraaktiválása',
  youAreVipMember: 'Te VIP tag vagy',
  byCancelingYourVip:
    'A VIP tagság felfüggesztésével az aktuális fizetési időszak lejárta után már nem lesz többé hozzáféréséd a következő funkciókhoz',
  unLimitedMessages: 'Korlátlan üzenetezés',
  seeAllPhotos: 'Összes fotó megtekintése',
  unlimtedUndo: 'Korlátlan számú visszavonás',
  deactivateAccount: 'Fiók deaktiválása',
  deleteAccount: 'Fiók törlése',
  showMe: 'Megjelenítés',
  limitSearchToDistance: 'Keresés korlátozása a következő távolságra',
  showAges: 'Életkor megjelenítése',
  men: 'Férfiak',
  women: 'Nők',
  toastPrefUpdatedSucc: 'Sikeresen frissítetted a beállításokat',
  receiveEmail: 'E-mail értesítés',
  whenSomebodySendsNewMsg: 'Amikor valaki üzenetet küld',
  whenSomebodyLikesMe: 'Amikor valaki lájkol',
  whenSomebodyVisitMyPof: 'Amikor valaki meglátogatja profilom',
  whenNewMembersComeOnline: 'Amikor az új felhasználók online vannak',
  withDiscountPromotions: 'Kedvezményes akciókkal',
  whenSomebodyFlirtsMe: 'Amikor valaki flörtöl velem',
  whenSomebodyAddsMeToFavorites: 'Amikor valaki hozzáad a kedvencekhez',
  whenNearbyMembersComeOnline: 'Amikor a közelben lévő tagok online lesznek',
  withNewWaysToMeetSingles: 'Új módokkal találkozhat szinglikkel',
  whenMyFavoritesComeOnline: 'Amikor a kedvenceim online lesznek',
  whenNearbyMembersUploadPhoto:
    'Amikor a közelben lévő tagok fotót töltenek fel',
  whenSomebodyMatchesWithMe: 'Amikor valaki illik hozzám',
  whenSomebodyTriesToConnectWithMe:
    'Amikor valaki megpróbál kapcsolatba lépni velem',
  notifEmailPauseFor30Days: 'Minden e-mail értesítés szüneteltetése 30 napig',
  notifEmailPausedUntil: 'E-mail értesítések szüneteltetve eddig',
  notifOptions: 'Értesítési opciók',
  notifUpdateSucc: 'Sikeresen frissítetted az értesítéseket',
  privacySettingsText1: 'Beállíthatod, hogy ki láthatja a profilod',
  privacySettingsText2: 'Válassz ki egy vagy több lehetőséget az alábbiakban',
  importantNotice: 'Fontos megjegyzés',
  byDeactivatingYourAccount:
    'A deaktiválás után nem férhetsz hozzá a következőkhöz, amíg nem aktiválod újra a fiókod',
  yourMatches: 'Partnerjelöltjeid',
  yourMessages: 'Üzeneteid',
  yourLikes: 'Lájkjaid',
  yourFavorites: 'Kedvenceid',
  allOtherInfo: 'A fiókodhoz kapcsolódó minden egyéb információ',
  yourProfileWillBeHidden:
    'Felhasználóink már nem láthatják profilod. E-maileket sem kapsz tőlünk, amíg nem aktiválod újra a fiókod. Koppints az alábbi nyomógombra ha deaktiválni szeretnéd a fiókod',
  areYouSure: 'Biztos vagy ebben?',
  yourAccountWillBeDeact: 'Fiókod deaktiválásra kerül',
  yesDeactivateAcc: 'Igen, deaktiválják a fiókot',
  accountSuccDeact: 'A fiókot deaktiváltuk',
  byDeletingYourAccount:
    'Fiókod törlésével az alábbi adatok véglegesen elvesznek',
  infoUsedToCreate: 'A fiók létrehozásához használt adatok',
  yourPhotos: 'Fényképeid',
  yourChatHistory: 'Csevegési előzményeid',
  thisActionIsNotReversible: 'Ez a művelet nem visszafordítható',
  tapTheButtonBellow: 'A fiók törléséhez, koppints az alábbi nyomógombra',
  yesDeleteAccount: 'Igen, töröljék a fiókot',
  accountSuccDelete: 'A fiókot töröltük',
  byReactivatingYourVip:
    'A VIP tagság előfizetésének újraaktiválásával a megterhelés az aktuális számlázási időszak végén történik',
  tapTheButtonToReactivateVip:
    'A VIP tagság ismételt aktiválásához, koppints az alábbi nyomógombra',
  yourMembershipWillExpire: 'A tagság lejárati ideje',
  yourMembershpWillRenew: 'A tagság megújulási ideje',
  yourVipMembershipWillReactivate: 'VIP tagságod ismételten aktiválásra kerül',
  yesReactivateVip:
    'Igen, szeretném ha VIP tagságom ismételten aktiválásra kerülne',
  noIveChangedMyMind: 'Nem, meggondoltam magam',
  membershipSuccessfullyReactivated: 'A tagság ismételten aktiválásra került',
  membershipSuccessfullyCanceled: 'A tagság sikeresen felfüggesztésre került',
  visibilityPreferences: 'Láthatósági beállítások',
  onlyShowMyProfileToPeopleISendMsg:
    'Csak azok láthatják a profilomat, akiknek üzenetet küldök',
  dataManagement: 'Adatkezelés',
  tapTheDownloadDataButtonBelowToViewYourAccountData:
    'A fiókadatok megtekintéséhez koppints az alábbi "Adatok lekérése" nyomógombra',
  downloadData: 'Adatok lekérése',
  yesDownload: 'Igen, letöltés kezdeményezése',
  yourDataWillBeDownloaded: 'Az adatok letöltésre kerülnek',
  changePassword: 'Jelszó módosítása',
  saveChanges: 'Módosítások mentése',
  currentPassword: 'Jelenlegi jelszó',
  confirmNewPassword: 'Új jelszó megerősítése',
  enterNewPassword: 'Írd be az új jelszót',
  passwordNotMatch: 'A jelszó nem egyezik',
  passwordChangedSuccess: 'Jelszó módosítva',
  registredAs: 'Regisztrálva:',
  userID: 'Felhasználói azonosító:',
  version: 'Verzió:',
  // Member
  cancel: 'Törlés',
  reportUser: 'Felhasználó jelentése',
  blockUser: 'Felhasználó tiltása',
  options: 'Opciók',
  startConversation: 'Beszélgetés kezdeményezése',
  requestPhotoTap: 'Koppints ide,',
  requestPhotoTapTo: 'és kérj fényképet',
  requestPhotoTapToFemale: 'és kérj fényképet',
  requestPhoto: 'és kérj fényképet',
  photoAlreadyRequested: 'Már kértél fényképet',
  youAlreadyRequestedPhoto: 'Már kértél fényképet ettől a felhasználótól',
  photoRequestSuccessfully: 'Sikeres fényképkérés',
  tellWhy: 'Mond el nekünk, hogy miért',
  inappropriatePhotos: 'Nem megfelelő fényképek',
  inappropriateMessages: 'Nem megfelelő üzenetek',
  badOfflineBehavior: 'Példátlan offline viselkedés',
  feelsLikeSpam: 'Hamisnak tűnik',
  reportChildSafetyConcern: 'Gyermekbiztonsági aggály bejelentése',
  other: 'Egyéb',
  report: 'Jelentés',
  reportComment: 'Hozzászólás jelentése..',
  blockMember: 'Felhasználó tiltása?',
  willNoLongerAppear: 'nem jelenik meg többé a partnerjelöltek listáján.',
  yesBlock: 'Igen, tiltsd le a felhasználót',
  noCancel: 'Nem, mégsem',
  userReportedSuccessfully: 'Sikeresen jelentetted a felhasználót',
  userBlockedSuccessfully: 'Sikeresen letiltottad a felhasználót',
  addedToFavorites: 'Kedvencekhez adva!',
  removedFromFavorites: 'Kedvencek közül eltávolítva!',
  sendAMessage: 'Üzenet küldése',
  sendUserAMessage: 'Üzenet küldése {user} felhasználónak',
  wellYouveComeThisFar: 'Nos, eljutottál idáig, akár mondhatnál is valamit',
  chatWith: 'Csevegj',
  outOfFlirts: 'Kifogytál a flörtikonokból',
  untilYouCanSend: 'Amíg újra tudsz flörtikont küldeni.',
  wantToMakeSure: 'Meg szeretnél győződni, hogy',
  seesYou: 'lát téged?',
  goVipGetFlirts:
    'Minősíts fel VIP tagságra és kapsz napi {num_of_flirts} flörtikont!',
  getMoreFlirts: 'Szerezz még több flörtikont',
  noNotThisTime: 'Nem, most még nem',
  flirtSent: 'Flörtikon elküldve és lájkolva',
  memberNotSharedAboutMe: 'Ez a tag nem osztotta meg a Rólam szóló adatait',
  dontWait: 'Ne várj',
  chooseFlirt: 'Válassz flörtikont:',
  sendFlirt: 'Flörtikon küldése',
  flirtIsSent: 'Flörtikon elküldve',
  // Chats
  chats: 'Csevegések',
  sentMessages: 'Elküldött üzenetek',
  yourConversations:
    'A többi taggal folytatott beszélgetéseid itt jelennek meg',
  yourSentMessages: 'A többi tagnak elküldött üzeneteid itt jelennek meg',
  // ChatRoom
  cannotSendMessageUnlessVip:
    "Csevegőüzeneteket 'boldog óra' alatt vagy VIP tagsággal küldhetsz",
  happyHour: 'Boldog óra',
  sendMessagesFree: 'Üzenetezz kedvedre ingyen',
  endsIn: 'Lejárati idő:',
  happyHourTonightAt: 'Ma este ',
  happyHourTodayAt: 'Ma ',
  // Contact us
  ContactUs: 'Kapcsolat\u00A0felvétel',
  ContactUsSupport: 'Kapcsolatfelvétel / Támogatás',
  WhatIsYourEmail: 'Mi az e-mail címed?',
  HowCanWeHelpU: 'Miben segíthetünk?',
  WriteMsg: 'Üzenet írása...',
  SendMsg: 'Üzenet küldése',
  EnterMsg: 'Írd be az üzenetet.',
  AlertMsgSentSuccessfully: 'Köszönjük! Üzenet sikeresen elküldve.',
  ToastMsgSentSuccessfully: 'Üzenet sikeresen elküldve',
  Subject: 'Téma',
  subject0: 'Általános kérdések',
  subject1: 'VIP tagság',
  subject2: 'Csalásjelentés',
  subject3: 'Lemondás',
  subject4: 'Fiók törlése',
  subject5: 'Egyéb',
  // Search
  refineSearch: 'Keresés finomhangolása',
  iamDoneRefining: 'Kész vagyok a finomhangolással',
  showAdvanced: 'Haladó beállítások megjelenítése',
  hideAdvanced: 'Haladó beállítások elrejtése',
  cancelSearch: 'Finomhangolás lemondása?',
  youWillLoseYourChanges:
    'Elveszíted az összes módosítást a keresési kritériumok kapcsán',
  yesLeavePage: 'Igen, el szeretném hagyni az oldalt',
  noContinueRefining: 'Nem, folytatom a finomhangolást',
  zeroMembersFound: 'Felhasználót találtunk',
  tap: 'Koppints',
  // tapHere: 'Koppints ide',
  // uploadAPhotoHere: 'Tölts fel egy fotót itt',
  toDisplayPreviousMembers: 'a korábbi tagok megjelenítéséhez.',
  toEditCurrentFilters: 'az aktuális szűrők módosításához.',
  resetSearch: 'Keresés visszaállítása',
  tryAgain: 'Próbáld újra',
  mile: 'Mérföld',
  miles: 'Mérföld',
  noUsers: 'Nincsenek felhasználók',
  // Quick Match Button text
  undo: 'Visszavonás',
  pass: 'Passz',
  like: 'Lájk',
  profile: 'Profil',
  undoNotAvailable: 'Nem áll rendelkezésedre ez a lehetőség ',
  nothingToUndo: 'Nincs mit visszavonni.',
  thisIsTheFirstUser: 'Ez az első felhasználó.',
  undoOnlyLastAction: 'Csak az utolsó műveletet vonhatja vissza.',
  dismissAd: 'Elvetés',
  seeMoreHere: 'Bővebben itt',
  tryChangingYourPreferences: 'Próbáld meg módosítani a beállításaid.',
  errorOnInviteActionTitle: 'Hiba történt a Villám Randi használata során',
  // It's Match
  itsMutual: 'Kölcsönös',
  youAndMemberLikeEachOther: 'Te és {member} kedvelitek egymást!',
  seeMoreMatches: 'Még több partnerjelölt',
  // My Profile
  edit: 'Szerkesztés',
  aboutMe: 'Rólam',
  youHaveNotSharedAbout: 'Még nem osztottad meg rólam szóló adataid',
  appearance: 'Megjelenés',
  situation: 'Családi állapot',
  addPhoto: 'Profilkép hozzáadása',
  // Edit Profile
  editProfile: 'Profil szerkesztése',
  reset: 'Visszaállítás',
  dob: 'Születési dátum',
  youWillLoseYourChangesProfile:
    'Elveszíted a profilodon végrehajtott összes módosítást',
  cancelEdit: 'Mégsem szeretnéd folytatni a profil szerkesztését?',
  noContinueEditing: 'Nem, folytatni szeretném',
  invalidMonth: 'Érvénytelen hónap',
  invalidDay: 'Érvénytelen nap',
  invalidAge: 'Legyél {min} és {max} év között',
  invalidFebruar: 'Februárban maximum 28 vagy 29 nap lehet',
  invalid30Day: 'Ebben a hónapban legfeljebb 30 nap lehet',
  invalid31Day: 'Ebben a hónapban legfeljebb 31 nap lehet',
  invalidLocation:
    'A tartózkodási hely érvénytelen, kérjük, válasszd ki a települést a legördülő listából',
  locationUpdated: 'Sikeresen frissítetted a tartózkodási helyed',
  setAsMainPhoto: 'Állítsd be profilképként',
  changeAsMainPhoto: 'Változtasd meg profilképre',
  deletePhoto: 'Fénykép törlése',
  areSureDeletePhoto: 'Biztosan törölni szeretnéd ezt a fényképet?',
  noKeepPhoto: 'Nem, nem szeretném törölni',
  yesDeletePhoto: 'Igen, törölni szeretném',
  editPhoto: 'Fénykép szerkesztése',
  profileUpdated: 'Sikeresen frissítetted a profilod',
  secondaryImageAlertText:
    'Ezt a képet az ügyfélszolgálat másodlagosként jelölte meg, és így nem állítható be profilképként.',
  reviewImageAlertText:
    'Ezt a képet még nem hagyta jóvá ügyfélszolgálatunk. Kérjük, próbáld meg később.',
  pendingReview: 'Függőben lévő áttekintés',
  // missing location
  locationReq: 'Tartozkódási hely kérése',
  pleaseEnterLocation: 'Add meg a tartózkodási helyed az alábbiakban.',
  withoutItOther: 'Enélkül a többi tag',
  cantSee: 'nem láthat,',
  likeOrMessage: 'lájkolhat vagy küldhet üzenetet neked.',
  submit: 'Küldés',
  // missing username
  completeYourProfile: 'Egészítsd ki profilod',
  itWillBeUsedOnYourProfileBio: 'Látható lesz a profilodon',
  userNameLettersAndNumbers: '(6-14 betű és számjegy)',
  submitUsername: 'Felhasználónév megerősítése',
  unknownError: 'Ismeretlen hiba történt',
  confirmUsername: 'Válassz egy felhasználónevet',
  orChooseNewOne: 'vagy válassz egy újat.',
  // missing username and location
  welcomeToSite: 'Üdvözlünk a(z) ' + config.TITLE + 'oldalon',
  yourAccountIsNowActive: 'Fiókod aktív!',
  itsGreatToHaveYou:
    'Örülünk, hogy csatlakoztál közösségünkhöz és már izgatottan várjuk a lehetőséget, hogy segítsünk neked megtalálni az ideális\u00A0partnerjelölted.',
  // error
  somethingWentWrong: 'Valami nem stimmel',
  networkError: 'Hálózati hiba',
  // invalid Token
  invalidToken: 'A munkamenet lejárt. Kérjük, jelentkezz be újra',
  // rejected Username
  rejectedUsername: 'Elutasított felhasználónév',
  // missing password
  missingPassword: 'Már majdnem kész...',
  missingPasswordText: 'Állítsd be a jelszót az alábbiakban',
  missingPasswordPlaceholder: 'minimum 6 karakter',
  submitPassword: 'Jelszó beállítása',
  // missing email
  missingEmail: 'Hiányzik az e-mail címed',
  missingEmailText:
    'Írd be e-mail címed, hogy értesíteni tudjunk amikor új üzeneted, lájkod érkezik vagy éppen valaki lecsekkolta a profiilod.',
  submitEmail: 'E-mail küldése',
  // Move and Scale
  moveAndScale: 'Mozgatás és méretezés',
  crop: 'Körülvágás',
  uploadError: 'Képfeltöltési hiba',
  whoops: 'Hoppá',
  itSeemsThatIsTaking:
    'Úgy tűnik, hogy a szokásosnál tovább tart a fénykép feltöltése. Kérlek próbáld újra.',
  // Missing Photo
  photoRequest: 'Fényképkérés',
  wait: 'Csak egy pillanat...',
  yourMissingPhoto: 'Még csak egy fénykép kell',
  membersWithoutPhotos:
    'A fénykép nélküli tagok 65%-kal kisebb valószínűséggel',
  likelyToReceive: 'kapnak lájkokat és üzeneteket',
  submitPhoto: 'Fotó feltöltése',
  takePhoto: 'Fénykép készítése',
  chooseFromLibrary: 'Válassz a fotótárból',
  // Missing Gender
  youLookingFor: 'Mit keresel',
  // Explicit Opt in Modal
  youAreAlmostDone: 'Majdnem kész vagy',
  iWouldLikeToGetSpecOffers:
    'Különleges ajánlatokat, kedvezményeket és havi akciós javaslatokat szeretnék kapni e-mailben',
  iHaveReadAndAgreeToPP: 'Elolvastam és elfogadom a feltételeket',
  ByJoiningTheSiteAgreeTos: 'Az oldalhoz való csatlakozással elfogadom a',
  optional: 'Opcionális',
  required: 'Kötelező',
  continue: 'Folytatás',
  // coreg
  toGetStarted: 'Mielőtt belevágnánk',
  tapHereToGetStarted: 'A kezdéshez koppints ide',
  hello: 'Hali',
  // Upgrade Modal
  membershipStatus: 'Tagsági állapot',
  upgradeToVipChoosePlan: 'Minősíts fel VIP tagsági díjcsomagra.',
  wantUnlimitedMessages: 'Üzenetezni szeretnél, korlátozások nélkül?',
  wantToReply:
    'Válaszolni szeretnél %gender% felhasználónak? Minősíts fel VIP tagságra!',
  getUnlimitedMessages: 'Üzenetezz kedvedre. Válassz tagsági díjcsomagot:',
  needToUndoMistake:
    'Vissza szeretnéd vonni a kedvelésed? Minősíts fel VIP tagságra!',
  getUnlimitedUndos: 'Korlátlan visszavonás. Válassz tagsági díjcsomagot:',
  whoViewedYourProfile: 'Ki látogatta meg profilod? Tudd meg!',
  peopleViewedYourProfile: 'Azok akik megtekinntették a profilod',
  chooseVipPlanToSeeThem: 'Válassz tagsági díjcsomagot és csekkold le őket:',
  wantToSeeWhoFavoritedYou:
    'Meg szeretnéd tudni, hogy ki adott kedvencei közé?',
  peopleFavoritedYou: 'Azok akik kedvennceikhez adtak téged',
  wantToSeeWhoLikesYou: 'Meg szeretéd tudni, hogy kinek jössz be?',
  peopleLikedYou: 'Azok akik lájkoltak téged',
  youAreBasic: 'Általános tagsággal rendelkező felhasználó',
  wantToUnlockPhotos: 'Le szeretnéd csekkolnni az összes fotót?',
  wantMoreFlirts: 'Szeretnél-e 5 napi flörtikont?',
  vipMembershipFeatures:
    'A VIP prémium tagsági szolgáltatások a következőket tartalmazzák:',
  vipMembershipFeaturesMobile: 'A VIP tagok a következőket kapják:',
  unlimited: 'Korlátlan',
  messaging: 'Üzenetezés',
  meetSomeoneTonight: 'Minősíts fel most - Találkozz valakivel ma este!',
  chooseVipPlanBelow: 'Válassz az alábbi VIP tagsági díjcsomagok közül:',
  messagingSub: 'Csevegj partner jelöltjeiddel',
  viewedSub: 'Csekkold le, hogy ki látogatta meg profilod',
  likesMeSub: 'Fedezd fel, hogy kinek tetszik a profilod',
  unlockPhotosSub: 'Lapozd át az összes felhasználó fotóit',
  favoritedMeSub: 'Nézd meg, ki az, aki igazán érdeklődik irántad',
  moreFlirtsSub: 'Növeld meg esélyeid napi 5 flörtikonnnal',
  goPrivateSub: 'Döntsd el, hogy ki láthatja a profilod',
  undoSub: 'Hibát vétettél? Vond vissza a csúsztatást!',
  select: 'Választás',
  vipMembersReceive: 'A VIP TAGOK A KÖVETKEZŐKET KAPJÁK',
  chooseYourPlan: 'VÁLASSZ TAGSÁGI DÍJCSOMAGOT:',
  enterPaymentDetails: 'ÍRD BE A FIZETÉSI RÉSZLETEKET:',
  creditCard: 'Hitelkártya',
  yourSubscriptionWillRebill:
    'Az előfizetésed automatikusan {0} tagsággá alakul át {1} {2}-én, és minden {0} alkalommal megújul, amíg le nem mondod. Bármikor lemondhatod a fiókod beállításain keresztül.',
  byTappingButtonBelow: 'Az alábbi gombra koppintva elfogadod a',
  andAuthorizeToCharge:
    'és felhatalmazol minket, hogy most és minden megújításkor megterheljük a %CARD_TYPE% kártyád.',
  continueToPayPal:
    'A vásárlás befejezése érdekében, lépj tovább a PayPal oldalára',
  proceedToPayPal: 'Tovább a PayPal oldalára',
  limitedTimeOffer: 'Korlátozott időre szóló ajánlat',
  promoHeader: '{date} VIP próbaidős tagság {price} díj ellenében',
  promoHeaderNoTrial: '{price} / {rebill_period} hónap(ok)',
  promoSubHeaderText: 'Ez egy exkluzív egyszeri ajánlat az új tagok részére',
  promoButtonText: 'Csak {price} - {date} próbaidős tagság',
  promoRebillsText:
    '*Megújulásra kerül minden {date} csak {price} díj ellenében, ha a VIP tagság nem kerül felfüggesztésre a próbaidőszak vége előtt*',
  accessToAllPhotos: 'Az összes fotó',
  toPremiumUsers: 'csak a Prémium felhasználók részére érhető el.',
  unlimitedMessaging: 'A korlátlan üzenetezés',
  upgradeTodayAndSendMessage:
    'Frissítsen még ma az üzenetek olvasásához és megválaszolásához',
  upgradeTodayAndSeePhotos:
    'Minősíts fel ma és csekkold le a következő felhasználó fényképeit:',
  mostPopular: 'Legnépszerűbb',
  notSuitableForCreditCard: 'Nem tudsz hitelkártyával fizetni?',
  weAreAccepting: 'Elfogadjuk a következő fizetési módot is ',
  payPal: 'PayPal ',
  // Welcome Back Modal
  weHaveAnOffer: 'Van egy ajánlatunk számodra:',
  discount: 'kedvezményes',
  onVipMembership: 'VIP tagsági díjcsomag!',
  tapHereToSave: 'Koppints ide és minősíts fel 50% kedvezménnyel!',
  toUnlockFeatures: 'vedd igénybe az összes prémium funkciót',
  upgrade: 'Felminősítés',
  upgradeNow: 'Minősíts fel azonnal',
  // Invalid Tagline
  invalidTaglineHeadline: 'Leírás elutasítva',
  invalidTaglineTitle: 'A "Rólam" rész szövegét nem hagytuk jóvá.',
  invalidTaglineReason: 'Indíték: ',
  invalidTaglineButton: 'Leírás frissítése',
  // Invalid Tagline
  photoRejectedHeadline: 'Fénykép elutasítva',
  photoRejectedTitle: 'Sajnáljuk...',
  photoRejectedParagraph: 'Egy vagy több feltöltött fotódat nem hagytuk jóvá.',
  photoRejectedReason: 'Indíték: ',
  photoRejectedButton: 'Új fénykép beküldése',
  viewed: 'Megtekintve',
  myProfile: 'Profilom',
  unlock: 'Feloldás',
  allPhotos: 'Összes fotó',
  undos: 'Visszavonások',
  moreFlirts: 'Még több flörtikon',
  goPrivate: 'Legyél láthatatlan',
  monthFor: 'Hónap',
  monthsFor: 'Hónap',
  mo: 'hó',
  month: 'hónap',
  months: 'havonta',
  monthly: 'havi',
  billed: 'számlázott',
  every: 'minden',
  saveUpTo: 'Takaríts meg',
  trialFor: 'Próbaidő',
  day: 'nap',
  days: 'Napok',
  free: 'díjmentes',
  trialRebillsAt: 'a próbaidős tagság újraszámlázásra kerül',
  per: 'által',
  best: 'Legjobb',
  value: 'Érték',
  // Checkout
  planSelected: 'Kiválasztott tagsági díjcsomag',
  paymentOption: 'Fizetési mód',
  billingDetails: 'Számlázási adatok',
  payByCard: 'Kártyával való fizetés',
  creditOrDebitCard: 'Fizess hitel- vagy bankkártyával',
  payWith: 'Fizess',
  pay: 'Pay',
  pal: 'Pal-el',
  for: 'mert',
  promoRebillsAt: 'a promó újraszámlázásra kerül',
  chooseMembershipPlan: 'Válassz tagsági díjcsomagot az alábbiakban',
  choosePaymentOption: 'Válassz fizetési módot az alábbiakban',
  enterCardDetails: 'Add meg a kártya adatait az alábbiakban',
  nameOnCard: 'A kártyán szereplő név',
  enterFullName: 'Add meg a teljes neved itt',
  creditCardNumber: 'Hitelkártya száma',
  cardNumber: 'Bankkártya száma',
  enterCardNumberHere: 'Add meg a kártya számát itt',
  expirationDate: 'Lejárati dátum',
  cvv: 'CVV/Biztonság',
  pleaseEnterCvv: 'Kérjük add meg a CVV biztonsági kódot',
  forYourPrivacyYouAreBilled:
    'A számlakivonaton a  szolgáltatás a következő néven fog szerepelni:',
  byCompletingThisTransaction:
    'A tranzakció végrehajtásáva igazolod, hogy legalább 18 éves vagy és elfogadod a',
  submitAndUpgrade: 'Küldés és VIP tagsági díjcsomagra való felminősítés',
  thisIsSecurePage: 'Ez egy biztonságos oldal.',
  dataTransferIsEncrypted:
    'Az adatátvitel titkosított biztonsági és védelmi okokból',
  tellUsYourFullName: 'Mondja el a teljes nevét, ahogy a kártyán van',
  andManyOthers: 'és sok más',
  youMissedANumber: 'Úgy tűnik, egy számot félreírt.',
  pleaseEnterYourCreditCard: 'Add meg a hitelkártya számát',
  pleaseEnterValidCreditCard: 'Add meg egy érvényes hitelkártya számát',
  pleaseEnterMonth: 'Add meg a hónapot',
  pleaseEnterValidMonth: 'Adj meg egy érvényes hónapot',
  pleaseEnterYear: 'Add meg az évet',
  pleaseEnterValidCvv: 'Érvényes CVV biztonsági kódot adj meg',
  pleaseAgreeToTos: 'Fogadd el az Általános Szerződési Feltételeket',
  thanksForBeingVip: 'Köszönjük, hogy felminősítettél',
  subscriptionUnavailable:
    'Az előfizetés nem érhető el, mert már VIP tagsági díjcsomaggal rendelkezel',
  onTheBackOfCard: 'A bankkártya hátoldalán',
  findYour: 'megtalálhatod a',
  cvvCvc: 'CVV/CVC',
  codeHere: 'biztonsági kódot.',
  hurryUp: 'Igyekezz!',
  thisOfferExpires: 'Az ajánlat lejárati ideje:',
  youAreInLuck: 'Szerencséd van!',
  thisPromoGotExtended:
    'Ezt a promót meghosszabbítottuk. Ragadd meg, mert bármikor visszavonhatjuk ezt az ajánlatot.',
  forYour: 'A számlázást',
  privacy: 'diszkréten',
  youAreBilled: 'végezzük',
  discreetly: 'el',
  as: 'mint',
  specialOffer: 'Különleges ajánlat',
  membershipInfo: 'Tagsági információk',
  // Success Upgrade
  successUpgrade: 'Sikeres felminősítés',
  welcomeToVip: 'Üdvözlünk VIP felhasználóink között!',
  youHaveSuccessfullyUpgraded: 'Sikeresen felminősítettél',
  vipPremiumMembership: 'VIP Prémium tagságra',
  importantInfo: 'Fontos információ!',
  pleasePrintThisPage:
    'Kérjük, nyomtasd ki ezt az oldalt, vagy írd le az alábbi információkat. Erre a jövőben szükséged lesz tagsági adataidnak eléréséhez vagy módosításához.',
  yourCreditCardBilled:
    'Bankkártyád a következő leíró terheli meg (diszkréten):',
  yourPayPalCardBilled:
    'PayPal fiókod a következő leíró terheli meg (diszkréten):',
  youWillBeDicreetlyBilled:
    'Számlád a következő leíró terheli meg (diszkréten):',
  membershipPurchased: 'Megvásárolt tagsági díjcsomag:',
  billingTerms: 'Számlázási feltételek:',
  vipPremium: 'VIP Prémium',
  total: 'Végösszeg',
  vip: 'VIP',
  trial: 'Próbaidős tagság',
  yourInfo: 'Személyes adataid:',
  fullName: 'Teljes név:',
  pleaseContactSupport:
    'Kérjük, vedd fel a kapcsolatot az ügyfélszolgálattal, ha bármilyen számlázási kérdésed van',
  billingSupport: 'Számlázási támogatás:',
  billingPhone: 'Számlázási telefonszám:',
  clickToAccessVip: 'A VIP funkciók igénybevételéhez, kattints ide',
  tapToAccessVip: 'Koppints a VIP funkciók eléréséhez',
  thirtyDays: '30 nap',
  // Process Payment
  processPayment: 'Csak egy pillanat, a befizetés feldolgozása folyamatban...',
  paymentProcessingError: 'A feldolgozás alatt hiba történt!',
  // Error Component
  serviceUnavailable: 'A szolgáltatás ideiglenesen nem érhető el',
  pleaseTryLater: 'Kérjük, próbáld meg később',
  // Another Client
  isOpenInAnotherWindow:
    'nyitva van egy másik ablakban. Bezárhatod ezt az ablakot.',
  useInThisWindow: 'Használd ebben az ablakban',
  // modal alert merging
  greatNews: 'Fantasztikus híreink vannak,',
  weAreHappy: ' Örömmel jelentjük be, hogy mától a(z), ',
  become:
    '{old_site} és a(z) {new_site} oldal összevonásra kerül és felhasználóink a(z) {new_site} oldalon folytathatják kalandjaikat! ',
  thisMeans:
    ' Ez egy nagyobb közösséget jelent minden felhasználónk számára, több jelöltet és még nagyobb esélyt arra, hogy megtaláljuk azt a különleges valakit.',
  dontWorry:
    'Ne aggódj, hiszen rád nézve, semmi sem változik. A bejelentkezési adatok, a profiladatok és az előzmények automatikusan átkerültek, így folytathatod ott, ahol abbahagytad. ',
  // ads
  ad: 'Hirdetés',
  sponsored: 'TÁMOGATOTT',
  findNiche:
    'Találj ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  meetNiche:
    'Ismerkedj ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  // ads random text, this is generated like this for easy transition to another niche
  adsRandomTextMeetNiche:
    'Ismerkedj ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextSingleNiche:
    'Szingli ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextFindNiche:
    'Találj ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextDateNiche:
    'Randizz ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextNicheRomance:
    config.NICHE_SINGULAR.replace(/\w/, (c) => c.toUpperCase()) + ' Románc',
  adsRandomTextLonelyNiche:
    'Magányos ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextNicheLove:
    config.NICHE_SINGULAR.replace(/\w/, (c) => c.toUpperCase()) + ' Szerelem',
  adsRandomTextWhantNiche:
    'Szeretnél ' +
    config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()) +
    '?',
  adsRandomTextNicheDates:
    config.NICHE_SINGULAR.replace(/\w/, (c) => c.toUpperCase()) + ' Randik',
  adsRandomTextMoreNiche:
    'Még több ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextSearchNiche:
    'Keress ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextNicheNow:
    config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()) + ' Most?',
  adsRandomTextNichesingles:
    config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()) + ' Szinglik',
  // niche gender names
  genderTsTvTg: 'TS/TV/TG',
  genderXdresser: 'Kereszt\u00ADöltöző',
  genderCouple: 'Pár',
  genderDom: 'Mester',
  genderFem: 'Domina',
  genderBiCouple: 'Biszexuális pár',
  genderSugarMale: 'Vonzó fiatalember',
  genderSugarBaby: 'Vonzó fiatal lány',
  genderHotWife: 'Szenvedélyes nej//\n\u00ADpár',
  genderMan: 'Férfi',
  lookingFor: 'keres',
  genderMilf: 'MILF',
  // onboarding
  moreInformation:
    'most pedig árulj el magadról egy picivel többet, hogy hozzád hasonló szinglikkel párosítsunk össze',
  howTallAreYou: 'Milyen magas vagy?',
  UseSliderHeight: 'A csúszka segítségével állítsd be a magasságod',
  WhatIsYourEthnicity: 'Mi a nemzetiséged?',
  specifyYourBodyType: 'Milyen a testalkatod',
  whatYouLookingFor: 'Árulj el egy picit többet az ideális partnerjelöltedről',
  idealMatchesAge: 'Hány éves az ideális partnerjelölted',
  howFarAway:
    'Milyen messzire lennél hajlandó elutazni, hogy megismerd az ideális partnerjelölted?',
  useSliderDistance: 'A csúszka segítségével állítsd be a távolságot',
  toHaveYourProfile: 'Mondj el egy picit többet magadról a többieknek...',
  writeSomethingAboutYourself:
    'Írj magadról valami érdekeset, olyat, ami a legjobban leírja a személyiséged',
  uploadAPhoto: 'Fénykép feltöltése',
  thisIsImportant: 'Ez a profilod legfontosabb része!',
  youOnlyHave: 'Nincs második esélyed első benyomást tenni.',
  tipPhoto:
    'Tipp: A legjobb eredmény érdekében a fotó legyen újabb keletű, csak te szerepelj rajta és a legjobb tulajdonságaid emelje ki. ',
  iUploadLater: 'Majd később feltöltök egy fotót...',
  congratulations: 'Gratulálunk...',
  yourProfileUpdated:
    'Profilod frissítettük, és egy lépéssel közelebb kerültél a tökéletes pár megtalálásához.',
  specialOfferNewMembers:
    'Különleges ajánlatunk részeként az új tagoknak ingyenes próbaidőszakot biztosítunk.',
  get25OffNow: 'Ragadd meg a 25% kedvezményt!',
  youWillBeRedirected: 'átirányítunk a felminősítési oldalra',
  seconds: 'másodpercen belül',
  aNewMember: 'Új tagként jogosult vagy a',
  get: 'Ragadd meg',
  initialOff: 'a 25% kedvezményt',
  selectedMembership: 'kiválasztott tagsági díjcsomag',
  selectYourMembership: 'Válasszd ki a tagsági díjcsomagot',
  newPrice: 'Új ár',
  oldPrice: 'Régi ár',
  iDontWantToPayLess: 'Nem, köszönöm, nem szeretnék kevesebbet fizetni.',
  addPhotoOnboarding: 'Fénykép feltöltése',
  uploadAnotherPhoto: 'Tölts fel még egy fényképet',
  finish: 'Befejezés',
  ifYourDoneUploadingPhotos: 'Ha befejezted a fényképek feltöltését',
  // california
  CCPATitle: 'Ne kerüljenek értékesítésre a személyes adataim',
  CCPAPersonal: 'Személyes adataim',
  youHaveAlreadyOptedOut: 'Már leiratkoztál.',
  // TransactionProgress
  transactionProgress: 'Tranzakciófeldolgozás',
  checkingSpecialOffers: 'Különleges ajánlatok ellenőrzése...',
  initializingTransaction: 'Tranzakció inicializálása...',
  // SpecialOffer
  congratulationsSpecialOffer: 'Gratulálunk!',
  youAreQualified: 'Jogosult vagy a különleges ajánlatunkra!',
  toAcceptThisOffer: 'Az elfogadáshoz, kattints a folytatásra az alábbiakban:',
  noThanksIDontWant: 'Nem, köszönöm, nem szeretnék kevesebbet fizetni.',
  forYourConvenience: 'A kényelmed érdekében, előfizetésed megújul',
  on: 'a következő napon',
  andEvery: 'és minden',
  daysThereafter: 'nap után, ha nem függeszted fel azt.',
  off: 'kedvezmény',
  yourSelectedMembership: 'kiválasztott tagsági díjcsomag.',
  // Transaction Declined
  transactionDeclined: 'Tranzakció elutasítva',
  yourCreditCardWasNotApproved:
    'Hitelkártyád nem tudjuk elfogadni ehhez a különleges tagsági ajánlatunkhoz.',
  butWait: 'de VÁRJ ... van még egy különleges ajánlatunk',
  tryA: 'Próbáld ki a(z)',
  forOnly: 'csak',
  acceptOffer: 'Elfogadom',
  membership: 'Tagság',
  // Measure System
  measureSystem: 'Mérési rendszer',
  imperial: 'Birodalmi egység',
  metric: 'Metrikus rendszer',
  // kink cam banner
  viewNow: 'Csekkold le most',
  youGotAFree: 'Ingyenes',
  // receipt page
  bonusMembership: 'Bónusz tagság',
  membersLoginArea: 'Belépés',
  // language
  language: 'Nyelv',
  // OneClick
  signInFromReferal:
    'Jelentkezz be a hivatkozó webhelyen található profiloddal',
  siteWouldLikeToAccess:
    config.TITLE +
    ' az alábbi információkhoz szeretne hozzáférni, annak érdekében, hogy regisztráljon téged ezen az oldalon:',
  permissionsToAccess:
    'Név, e-mail, születési dátum, tartózkodási hely és az alapvető társkereső profil adatai',
  iConsentToDetailsAndRegister:
    'Hozzájárulok ahhoz, hogy ezeket az adatokat a profilom regisztrálásához használják, és megerősítem, hogy elfogadom ',
  allow: 'Engedélyezés',
  byClickingAllow:
    'Az Engedélyezés gombra kattintva beleegyezel abba, hogy ezeket az adatokat felhasználja a(z) ' +
    config.TITLE +
    ' oldal, annak érdekében, hogy regisztráljon a téged a társkereső oldalra, és megerősíted, hogy elfogadod az alább linkelt Általános Szerződési Feltételeket. Alternatívaként használhatod a ',
  standardRegistrationForm: 'szabványos regisztrációs űrlapot is',
  congratulationsYouGotFree:
    'Gratulálunk, INGYENES tagságot kapott itt: {site_name}.',
  toGetLoggedInto: ' hogy bejelentkezzen az oldalra.',
  // RefundCreditCard
  refundCreditCard: 'Visszatérítés új hitelkártyával',
  refundCreditCardSuccess: 'Visszatérítési kérelmét sikeresen elküldtük.',
  // Nearby Connect
  nearbyConnect: 'Közeli csatlakozás',
  nearbyDecline:
    'Nem, köszönöm, most nem szeretném elküldeni, később megteszem.',
  introduceMyself: 'Bemutatni magam',
  distance: 'Távolság',
  anyDistance: 'Bármilyen távolság',
  message: 'Üzenet',
  sentByNearbyConnect: 'A KözeliCsatlakozás küldte',
  typeYourMessageHere: 'Írja be üzenetét ide',
  sendThisToMyNewMatches:
    'Küldje el ezt minden új meccsnek is, amikor csatlakoznak',
  successNearbyConnect: 'Sikeresen beállította a Nearby Connect funkciót',
  nearbyConnectTitle:
    'Azonnal vegye fel a kapcsolatot több száz taggal! Csak a profilodnak megfelelő felhasználók kapják meg ezeket az üzeneteket. A kezdéshez írja be az alábbi üzenetet:',
  nearbyConnectAlert:
    'A Nearby Connect üzenetek egyedi üzenetek más valódi tagoktól, akik tökéletes párja lehet. Ezeket az üzeneteket a rendszer automatikusan csak azoknak a felhasználóknak küldi el, akik megfelelnek az adott felhasználói profilnak.',
  nearbyUnavailable:
    'Sajnáljuk, a NearbyConnect funkció jelenleg nem érhető el. Ez a funkció 30 naponként egyszer használható. Köszönöm a megértést.',
  nearbyFeatureUsed: '{date}-n használta a NearbyConnect funkciót.',
  toKeepNearbyFree:
    'Annak érdekében, hogy a NearbyConnect ingyenes maradjon, 30 naponként csak egy bemutatkozásra korlátozzuk.',
  ifYouLikeToBeIntroduced:
    'Ha több tagnak szeretne bemutatkozni, térjen vissza {date}.',
  nearbyConnectValentineTitle: 'Valentin különleges',
  nearbyConnectValentineText1:
    'Közeleg a Valentin-nap. Korlátozott ideig elküldjük a ',
  nearbyConnectValentineText2: 'INGYENES bemutatkozó üzenet ',
  nearbyConnectValentineText3:
    'több száz felhasználó számára, akik megfelelnek az Ön preferenciáinak. Csak írja be az alábbi üzenetet a kezdéshez:',
  // subscription status
  subscriptionStatus: 'Előfizetés állapota',
  subscritpionStatusManageLink1: 'Gratulálunk! Ön VIP tag. Kérlek látogasd ',
  subscritpionStatusManageLink2: ' az előfizetés kezelésére.',
  subscriptionUpgradeLink1: 'Ön alaptag. ',
  subscriptionUpgradeLink2: ' Frissítsen VIP-re most!',
  // Manage Nearby Connects
  manageNearbyConnects: 'A Nearby Connect kezelése',
  sendNewNearbyConnectMessage: 'Új NearbyConnect üzenet küldése',
  activeUntil: 'Aktív ig',
  sendToNewJoins: 'Küldés új csatlakozásokhoz',
  update: 'Frissítés',
  disable: 'Letiltás',
  nearbyConnectUpdated: 'A Nearby Connect sikeresen frissítve',
  nearbyConnectWillBeAvailable:
    'A Nearby Connect legközelebb a következő napon lesz elérhető ',
  canChangeMessageOn: 'Bekapcsolhatja az üzenetet',
  getInTouchWith:
    'Azonnal vegye fel a kapcsolatot több száz taggal! Csak a profilodnak megfelelő felhasználók kapják meg ezeket az üzeneteket.',
  // Cookie Consent
  cookieConsentText:
    'Az oldal sütiket használ. Az oldalon való böngészés folytatásával Ön kifejezetten hozzájárul a cookie-k használatához.',
  cookieConsentDetailsLinkText: 'Részletek',
  cookieConsentButtonText: 'Megértem',

  cookieConsentDeclineButtonText: 'Bezárás',
  cookieTitle: 'Ez az oldal cookie-kat használ',
  cookieSubTitle:
    'Cookie-kat és egyéb nyomkövetési technológiákat használunk, hogy javítsuk a böngészési élményt a weboldalunkon, hogy személyre szabott tartalmat és célzott hirdetéseket jelenítsünk meg, elemezzük weboldalunk forgalmát, és megértsük, honnan érkeznek látogatóink.',
  cookieAcceptAllCookies: 'Mindent elfogad',
  cookieDeclineAllCookies: 'Összes elutasítása',
  cookieManagePreferences: 'Módosítsa a Beállításokat',
  cookieClosePreferences: 'Zárja be a Beállítások lehetőséget',
  cookieNecessaryTitle: 'Szükséges',
  cookieNecessaryDescription:
    'Ezek a cookie-k elengedhetetlenek ahhoz, hogy a weboldalunkon keresztül elérhető szolgáltatásokat biztosítsunk Önnek, és lehetővé tegyük webhelyünk bizonyos funkcióinak használatát. Ezen sütik nélkül bizonyos szolgáltatásokat nem tudunk biztosítani Önnek weboldalunkon.',
  cookieActiveText: 'Aktív',
  cookieAlwaysActiveText: 'Mindig aktív',
  cookieInactiveText: 'Inaktív',
  cookieFunctionallityTitle: 'Funkcionalitás',
  cookieFunctionallityDescription:
    'Ezeket a sütiket arra használjuk, hogy személyre szabottabb élményt nyújtsunk weboldalunkon, és emlékezzünk a webhelyünk használata során hozott döntéseire. Például funkcionális cookie-kat használhatunk, hogy megjegyezzük nyelvi beállításait vagy megjegyezzük bejelentkezési adatait.',
  cookieAnalyticsTitle: 'Analitika',
  cookieAnalyticsDescription:
    'Ezeket a sütiket arra használjuk, hogy információkat gyűjtsünk a weboldalunk forgalmának elemzéséhez, valamint a látogatók webhelyünk használatának elemzéséhez. Például ezek a cookie-k nyomon követhetnek olyan dolgokat, mint például, hogy mennyi időt tölt a webhelyen, vagy milyen oldalakat látogat meg, ami segít megérteni, hogyan javíthatnánk webhelyünket az Ön számára. Az ezen nyomkövető és teljesítmény cookie-kon keresztül gyűjtött információk nem azonosítanak egyetlen látogatót sem.',
  cookieMarketingTitle: 'Marketing',
  cookieMarketingDescription:
    'Ezek a cookie-k olyan hirdetések megjelenítésére szolgálnak, amelyek böngészési szokásai alapján valószínűleg érdekelhetik Önt. Ezek a cookie-k, amelyeket tartalom- és/vagy hirdetési szolgáltatóink szolgálnak ki, egyesíthetik a webhelyünkről gyűjtött információkat más olyan információkkal, amelyeket egymástól függetlenül gyűjtöttek össze az Ön webböngészőjének webhelyhálózatukon végzett tevékenységeivel kapcsolatban. Ha úgy dönt, hogy eltávolítja vagy letiltja ezeket a célzási vagy hirdetési cookie-kat, továbbra is látni fogja a hirdetéseket, de előfordulhat, hogy nem relevánsak az Ön számára.',
  cookieOtherTitle: 'Egyéb',
  cookieOtherDescription: 'Néhány más süti',
  cookieSavePreferences: 'Mentse a beállításokat és zárja be',
  cookiePreferencesTitle: 'Válassza ki a Beállításokat',
  manageCookies: 'Cookie-k kezelése',
  cookiesViewDetails: 'Részletek megtekintése',
  cookiesProviders: 'Cookie-szolgáltatók',
  cookiesYahoo:
    'A Yahoo a tartalom és a hirdetések személyre szabásához használja.',
  cookiesGoogleDetectSpam: 'Spam, csalás és visszaélés észlelésére szolgál.',
  cookiesGoogleAds:
    'A Google hirdetések személyre szabására szolgál a legutóbbi keresések és interakciók alapján.',
  years: 'évek',
  year: 'év',
  cookiesGoogleAdDelivery:
    'A hirdetések megjelenítésére vagy újracélzásra szolgál.',
  cookiesGoogleUseOurSite:
    'A cookie-k arra szolgálnak, hogy információkat gyűjtsenek arról, hogy a látogatók hogyan használják webhelyünket.',
  cookiesGoogleDistinguishUsers: 'A felhasználók megkülönböztetésére szolgál.',
  cookiesGoogleCrossSite:
    'Ez a süti arra szolgál, hogy megakadályozza, hogy a böngésző elküldje ezt a cookie-t a webhelyek közötti kérésekkel együtt.',
  cookiesGoogleUniqueIdTracking:
    'Ezek a cookie-k egyedi azonosítót használnak nyomkövetési célokra.',
  cookiesGoogleProtectData:
    'Biztonsági cookie, amely megvédi a felhasználó adatait a jogosulatlan hozzáféréstől.',
  cookiesGoogleTrackConversions:
    'A konverziók tárolására és követésére szolgál.',
  cookiesBingAds:
    'Ez a süti lehetővé teszi releváns hirdetések megjelenítését a látogatók számára.',
  cookiesBingTracking:
    'A Bing Ads által használt Microsoft User Identifier nyomkövető cookie.',
  cookiesBingTrackingAdvertising:
    'Ez egy nyomkövető süti, amelyet a Microsoft Bing hirdetései használnak, hogy lehetővé tegyük számunkra, hogy kapcsolatba léphessünk olyan látogatóval, aki korábban már meglátogatta webhelyünket.',
  cookiesBingClarityID:
    'Megmarad a Clarity felhasználói azonosítója, és az adott webhelyre jellemző beállítások ugyanahhoz a felhasználói azonosítóhoz vannak rendelve.',
  cookiesBingClarityMultiple:
    'Egy felhasználó több oldalmegtekintését egyetlen Clarity munkamenet-felvételbe kapcsolja össze.',
  cookiesFacebookTracking:
    'A webhelyek látogatásainak tárolására és nyomon követésére szolgál.',
  cookiesFacebookUniqueId:
    'A böngésző egyedi azonosítójának tárolására szolgál, amely többek között segít megvédeni Önt a csalástól.',
  cookiesFacebookDevicePixelRatio:
    'A képernyő eszköz pixelarányának rögzítésére szolgál, valamint arra, hogy engedélyezte-e a nagy kontrasztú módot, hogy optimálisan tudjuk megjeleníteni webhelyeinket.',
  cookiesFacebookMarketing:
    'A hirdetések megjelenítésére vagy újracélzásra szolgál.',
  cookiesGoogleDoubleClick:
    'A Google DoubleClick arra használja, hogy regisztrálja és jelentse a webhely felhasználójának tevékenységeit, miután megtekintette vagy rákattintott a hirdető hirdetésére, azzal a céllal, hogy mérje a hirdetés hatékonyságát, és célzott hirdetéseket mutasson be a felhasználónak.',
  cookiesBingRefreshMuid: 'Azt jelzi, hogy frissíteni kell-e a MUID-ot.',
  cookiesRomanceGuard:
    'Csalás, spam, rosszindulatú programok észlelésére szolgál.',
  cookiesTaboolaUniqueId:
    'Egyedi, particionált felhasználói azonosítót rendel hozzá, amelyet a Taboola hozzárendelési és jelentéskészítési célokra használ, valamint az adott felhasználóhoz szabott ajánlásokat egy hirdetővel vagy megjelenítővel folytatott interakciók alapján.',
  cookiesSnapchatId: 'A látogató azonosítására szolgál.',
  cookiesSnapchatTrackId:
    'Egyedi azonosítót állít be a látogató számára, amely lehetővé teszi a harmadik fél hirdetői számára, hogy releváns hirdetésekkel célozzák meg a látogatót. Ezt a párosítási szolgáltatást harmadik felek hirdetési központjai biztosítják, amely lehetővé teszi a hirdetők számára a valós idejű ajánlattételt.',
  cookiesSnapchatPixelId:
    'Annak meghatározására szolgál, hogy egy harmadik féltől származó címke meghívásra kerül-e egy Snap Ads Pixelben.',
  cookiesVWOVisits: 'Egyedi látogatások tárolására szolgál.',
  cookiesVWOTest: 'Arra használják, hogy leolvassák, elhelyezhetők-e cookie-k.',
  cookiesVWOSafari:
    'Ez a süti egy üveg az összes sütiből. Jelenleg csak a Safari böngészőhöz készült. A jövőben ez felváltja az összes VWO cookie-t. MEGJEGYZÉS: Ennek a sütinek a tényleges lejárata nem releváns, mivel tárolja a benne beállított cookie-k lejárati idejét, és folyamatosan lejár.',
  cookiesVWODS:
    'Ez a cookie állandó látogatói szintű adatokat tárol a VWO Insights számára.',
  cookiesVWOExpiration: 'A számla megőrzési időszakától függ.',
  cookiesVWOUniqueId:
    'Ez a cookie egyedi azonosítót generál minden látogató számára, és a VWO jelentésszegmentáló funkciójához használjuk. Lehetővé teszi az adatok kifinomultabb megtekintését is.',
  cookiesVWOUniqueVisits:
    'Ez a cookie kiszámítja a webhely egyedi látogatóinak forgalmát.',
  cookiesAppsFlyer:
    'Ezzel a szolgáltatással észleljük a felhasználók eszközeit, például iOS iPhone-t vagy Android Phone-t, hogy szalaghirdetéseket jelenítsünk meg a felhasználók számára, jelezve, ha natív alkalmazást szeretnének telepíteni az iStore-ból vagy a Google Play Áruházból.',
  cookiesTikTok:
    'Reklámkampányai teljesítményének mérésére és javítására, valamint a TikTokon a felhasználói élmény (beleértve a hirdetéseket) személyre szabására.',
  cookiesRaygun:
    'A Raygun hiba-, összeomlás- és teljesítményfigyelést biztosít a szoftvercsapatok számára.',
  name: 'Név',
  description: 'Leírás',
  duration: 'Időtartam',
  url: 'URL',
  domain: 'Tartomány',

  // email verification
  welcome: 'Üdvözöljük',
  emailConfirmationTitle:
    'Erősítse meg e-mail címét, hogy kapcsolatban maradhasson!',
  emailConfirmationDesc:
    'Az Ön e-mail címe még nincs megerősítve, ezért jelenleg nem kap e-maileket vagy üzeneteket!',
  weRecomend:
    'Javasoljuk, hogy kattintson a gombra a link újraküldéséhez, majd ellenőrizze e-mail fiókját.',
  resendConfirmation: 'ERŐSÍTŐ E-MAIL ÚJBÓLI ELKÜLDÉSE',
  ifForAnyReason: 'Ha valamilyen okból meg szeretné változtatni e-mail címét, ',
  dontSeeIt: 'Nem látja?',
  andWeWillResend:
    'és mi azonnal újra elküldjük az e-mailt, hogy könnyen megtalálható legyen!',
  checkSpamFolder: 'Ellenőrizze a spam mappát',
  ifYouDoNotSeeYourMessage:
    'Ha nem látja üzenetét a bejövő levelek között, ellenőrizze a spam mappát.',
  thenSelect: 'Ezután válassza ki az üzenetet, és jelölje meg NEM SPAM-ként.',
  needHelp: 'Segítségre van szüksége? ',
  ClickHereForMoreInfo: 'Kattintson ide további információkért',
  addUsToYouContacts: 'Adjon hozzá minket a névjegyzékéhez',
  beSureToAdd: 'Feltétlenül adja hozzá',
  notifyEmail: 'notify@nearbynotifications.com',
  toYourAddressBook:
    'címjegyzékébe/névjegylistájába, hogy üzenetei és flörtölései eljussanak a postaládájába.',
  copiedToClipboard: 'Vágólapra másolva',
  cantWait:
    'Alig várjuk, hogy segítsünk megtalálni a tökéletes társát. Több ezer tagunk várja, hogy találkozhasson Önnel...',
  seeYou: 'Találkozunk odabent!',
  emailConfirmationDecline:
    'Nem, köszönöm, nem szeretném most elküldeni, később megteszem.',
  emailConfirmationToast:
    'Az e-mail megerősítő link sikeresen elküldve. Kérjük, ellenőrizze e-mail fiókját.',

  // addUsToContactsInfo
  addUsToYouContactsList:
    'Adja hozzá a ' +
    config.DOMAIN.replace(/https?:\/\//, '').toUpperCase() +
    ' webhelyet a névjegyzékéhez, hogy elkerülje, hogy ',
  missingAnyMessage: 'LEMARADJON bármilyen üzenetről!',
  contactsInfoDetails:
    'Adja hozzá a ' +
    config.DOMAIN.replace(/https?:\/\//, '').toUpperCase() +
    ' webhelyet a névjegyzékéhez vagy a névjegyek listájához, hogy ne maradjon le semmilyen üzenetről vagy flörtről.',
  openMessageStep:
    'Nyissa meg az e-mail küldőtől származó üzenetet, akit el szeretne menteni a Gmail névjegyeként.',
  hoverCursorStep: 'Vigye az egérkurzort a küldő nevére az e-mail tetején.',
  selectAddToContactsStep: 'Válassza a Névvég hozzáadása a felugró menüben.',
  resendConfirmationLinkText: 'Kattintson ide a megerősítő link újraküldéséhez',
  toMakeItEasier: 'hogy könnyebben megtalálható legyen a postafiókjában!',
  checkGmailInbox: 'ELLENŐRIZZE A GMAIL BEJÖVŐ LEVELEIT',

  // checkSpamFolder
  beSure: 'Győződjön meg róla, hogy ellenőrzi a',
  spamFolder: 'Spam mappát',
  ifYouDoNotSeeMessage: 'ha nem látja üzenetünket a bejövő levelek között!',
  spamFolderDetails:
    'Ha úgy találja, hogy az üzenetünk tévesen került a spam közé, megjelölheti azt nem spammé.',
  unmarkingAMessage:
    'Egy üzenet megjelölésének megszüntetése automatikusan áthelyezi azt a bejövő levelek közé.',
  openSpamFolderStep: 'Kattintson a Spam elemre az oldal bal oldalán.',
  selectMessageStep: 'Válassza ki az üzenetet.',
  markAsNotSpamStep: "Kattintson a 'Nem spam' gombra az oldal tetején.",

  // change email
  changeEmail: 'E-mail cím megváltoztatása!',
  newEmailAddress: 'Új e-mail cím',
  currentEmailAddress: 'Jelenlegi e-mail cím',

  // cancel web subscription
  cancelVipMembership: 'VIP tagság lemondása',
  yesCancelVip: 'Igen, mondja le a VIP tagságot',
  noKeepVip: 'Nem, maradjon a VIP tagság',
  doYouWantToGiveUpVip: 'Biztosan lemond ezekről a nagyszerű funkciókról?',
  cancelSubscriptionSuccess: 'Az előfizetés sikeresen lemondva.',
  resubscribeVip: 'VIP újraelőfizetés',
  weWillNotRenewYourSubscription:
    'Az előfizetésed jelenleg aktív, azonban lemondtad. Amint az előfizetésed lejár, nem kerül megújításra, és elveszíted a prémium funkciókhoz való hozzáférést. Az előfizetésed lejárta előtt bármikor újra előfizethetsz, hogy továbbra is élvezhesd az előnyöket.',
};
